'use strict';
(function($){
	/*
	 * Vetology.VetologyCache widget
	 *
	 * @description Adds image handling functionality to a Vetology page
	 *
	 * @options					See description for each option
	 * @options canvas			The canvas descriptor where things wil be drawned
	 *							image_viewer
	 *								container	The main container of the canvas
	 *								canvas		The actual canvas where the images are rendered
	 *							image_diagnosys
	 *								original The details of the image of the study
	 *									container	The main container of the canvas
	 *									canvas		The actual canvas where the images are rendered
	 *								compare The details of the image that the study is being compared against
	 *									container	The main container of the canvas
	 *									canvas		The actual canvas where the images are rendered
	 * 							layout The format in which images are displayed values are 0 for side by side, 1 for one on top of the other
	 * @options ratio			The ratio of width/height that should be used the images will always use full width of the calculated space and the height will always be the width * ratio
	 * @options body_loading	A class name to add to the body when anything is loading
	 * @options tools			The selectors for the buttons that control the enabled tool/effect/interface
	 * @options interfaces		The selectors for the containers where an interface is located 
	 *							interfaces.global is a class that every interface contains so they can all be disabled
	 *							interfaces.image_over is a class that will be used to trigger the event handlers on the images
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.VetologyCache',
		{
			"options": {
				"queue": {
					"download": {},
					"download_secondary": {},
					"active": 0,
					"slots": 6
				},
				"debug": false,
				"QuotaExceededError": false,
				"QuotaLimit": 485,
				"items": [],
				"images": [],
				"purger": {
					"purging": false,
					"target": 0
				},
				"images_used": [],
				"is_ready": false,
				"servers": {
					"amount": 5
				},
				"workers": {
					"max": navigator.hardwareConcurrency || 4,
					"workers": []
				},
				"db_size": 0,
				"data_usage": {
					"total": 0,
					"downloaded": 0,
					"cached": 0,
					"downloaded_bytes": 0,
					"cached_bytes": 0,
				},
				"database": {
					"version": 1,
					"flushed": false,
					"support": false,
					"name": "vetology",
					"schema": {
						"name": "donwloads",
						"keyPath": "id",
						"autoIncrement": true,
						"exists": false,
						"trash": false,
					},
					"indexes": {
						"id": {
							"unique": true,
							"multiEntry": false
						},
						"stamp": {
							"unique": true,
							"multiEntry": true
						},
					},
					"ready": false,
				},
				"no_matches": "data:image/jpeg;base64,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",
				"flushed_message": "The image database has been flushed by another tab<br>Please reload this page if you need to resume work on the case."
			},
			/*
			 * Vetology.PatientSwissKnife._init
			 *
			 * @description	Initializes toolset behavior behavior
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._applyPolyfills();
				o.options.workers.support = typeof Worker !== "undefined" && o.options.workers.max > 0;
				o.options.workers.support = false;
				if(o.options.database.support){
					window.addEventListener('storage', function(event){
						if(event.newValue != null){
							switch(event.key){
								case "db_modified":
									o._setStorageUsed();
								break;
								case "db_flushed":
									o.options.database.flushed = true;
									$("body").Vetology("vetologyLoadStart", o.options.flushed_message, o.options.flushed_message);
									if(o.options.database.connection){
										o.options.database.connection.close();
									}
								break;
							}
						}
					});
				}
				var s = o.options.QuotaLimit * 1048576;
				o.options.QuotaLimit = s;
				o.options.canvas = document.createElement("canvas");
				o.options.currentImageId = void 0;
				if(o.options.database.support){
					$.when(o._getDatabase()).then(
						function(){
							if(o.options.database.flushed){
								o.options.database.connection.close();
								$("body").Vetology("vetologyLoadStart", o.options.flushed_message, o.options.flushed_message);
							} else {
								setInterval(
									function(){
										o._processDownloadQueue();
									}, 10
								);
								$("body").on("click", ".data_db_size_flush", function(){
									o.flushDB();
								});
							}
						}
					);
				} else {
					o.options.is_ready = true;
					$(".data_db_size_flush").addClass("hide");
					setInterval(
						function(){
							o._processDownloadQueue();
						}, 10
					);
				}
			},
			"_applyPolyfills": function(){
				if(typeof Promise === "undefined"){
					$.getScript("//cdn.jsdelivr.net/bluebird/3.5.0/bluebird.js");
				}
				if (typeof Object.assign != 'function') {
				  Object.defineProperty(Object, "assign", {
					value: function assign(target, varArgs) {
					  'use strict';
					  if (target == null) {
						throw new TypeError('Cannot convert undefined or null to object');
					  }

					  var to = Object(target);

					  for (var index = 1; index < arguments.length; index++) {
						var nextSource = arguments[index];

						if (nextSource != null) {
						  for (var nextKey in nextSource) {
							if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							  to[nextKey] = nextSource[nextKey];
							}
						  }
						}
					  }
					  return to;
					},
					writable: true,
					configurable: true
				  });
				}
				if (!Array.prototype.find) {
				  Object.defineProperty(Array.prototype, 'find', {
					value: function(predicate) {
					  if (this == null) {
						throw new TypeError('"this" is null or not defined');
					  }

					  var o = Object(this);
					  var len = o.length >>> 0;
					  if (typeof predicate !== 'function') {
						throw new TypeError('predicate must be a function');
					  }
					  var thisArg = arguments[1];
					  var k = 0;
					  while (k < len) {
						var kValue = o[k];
						if (predicate.call(thisArg, kValue, k, o)) {
						  return kValue;
						}
						k++;
					  }
					  return undefined;
					},
					configurable: true,
					writable: true
				  });
				}
				if (!Array.prototype.findIndex) {
				  Object.defineProperty(Array.prototype, 'findIndex', {
					value: function(predicate) {
					  if (this == null) {
						throw new TypeError('"this" is null or not defined');
					  }

					  var o = Object(this);
					  var len = o.length >>> 0;
					  if (typeof predicate !== 'function') {
						throw new TypeError('predicate must be a function');
					  }
					  var thisArg = arguments[1];
					  var k = 0;
					  while (k < len) {
						var kValue = o[k];
						if (predicate.call(thisArg, kValue, k, o)) {
						  return k;
						}
						k++;
					  }
					  return -1;
					},
					configurable: true,
					writable: true
				  });
				}
			},
			"unsetDownloadQueue": function(){
				var o = this;
				$.each(o.options.queue.download, function(imageId, t){
					if(!t.active){
						o.options.queue.download_secondary[imageId] = t;
						delete o.options.queue.download[imageId];
						o.options.images[imageId].state = 1;
					}
				});
			},
			"_processDownloadQueue": function(){
				var o = this;
				if(o.options.queue.active > o.options.queue.slots){
					return;
				}
				$.each(o.options.queue.download, function(imageId, t){
					if(!t.active){
						o._triggerDownload(imageId);
						if(o.options.queue.active > o.options.queue.slots){
							return false;
						}
					}
				});
				if(o.options.queue.active > o.options.queue.slots){
					return;
				}
				$.each(o.options.queue.download_secondary, function(imageId, t){
					if(!t.active){
						o._triggerDownload(imageId, true);
						if(o.options.queue.active > o.options.queue.slots){
							return false;
						}
					}
				});
			},
			"_triggerDownload": function (imageId, secondary, attempt = 1) {
				var o = this;
				var aborting = false; // a watchdog abort is in flight; the non-200 handler must not double-handle it
				var settled = false;  // this attempt has already retried or failed
				var MAX_ATTEMPTS = 6;
				var XHR_TIMEOUT = 900000; // 15 minutes
				function retryOrFail(reason) {
					if (settled) {
						return; // one failure can fire several handlers (readystatechange + onerror, etc.)
					}
					settled = true;
					clearTimeout(to);
					if (attempt < MAX_ATTEMPTS) {
						console.log('%c ' + reason + ' — retrying image (attempt #' + attempt + ' of ' + MAX_ATTEMPTS + ')\n' + imageId, 'color: orange');
						setTimeout(function () {
							o._triggerDownload(imageId, secondary, attempt + 1);
						}, 250 * attempt);
						return;
					}
					o.options.queue.active--; // slot is released only when the image gives up for good
					console.log('%c Failed to download image ' + imageId + ' after ' + MAX_ATTEMPTS + ' attempts (' + reason + ')', 'color: red');
					if (typeof o.options.queue.download_secondary[imageId] != "undefined") {
						$.each(o.options.queue.download_secondary[imageId].deferred, function (i, d) {
							d.reject(imageId, reason);
						});
						delete o.options.queue.download_secondary[imageId];
					}
					if (typeof o.options.queue.download[imageId] != "undefined") {
						$.each(o.options.queue.download[imageId].deferred, function (i, d) {
							d.reject(imageId, reason);
						});
						delete o.options.queue.download[imageId];
					}
				}

				if (typeof o.options.queue.download_secondary[imageId] != "undefined") {
					o.options.queue.download_secondary[imageId].active = true;
				}
				if (typeof o.options.queue.download[imageId] != "undefined") {
					o.options.queue.download[imageId].active = true;
				}
				if (attempt == 1) { 
					o.options.queue.active++;
				}
				var arraybuffer;
				if(imageId == "no_matches"){
					arraybuffer = o.Base64Binary.decode(o.options.no_matches);
					o.options.data_usage.total --;
					o.options.db_size += arraybuffer.byteLength + imageId.length;
					if(typeof o.options.queue.download_secondary[imageId] != "undefined"){
						$.each(o.options.queue.download_secondary[imageId].deferred, function(i, d){
							d.resolve(imageId, arraybuffer);
						});
						delete o.options.queue.download_secondary[imageId];
					}
					if(typeof o.options.queue.download[imageId] != "undefined"){
						$.each(o.options.queue.download[imageId].deferred, function(i, d){
							d.resolve(imageId, arraybuffer);
						});
						delete o.options.queue.download[imageId];
					}
				} else {
					var rand = ((o.options.queue.active + attempt - 2) % (o.options.queue.slots + 1)) + 1;
					var id = imageId;
					var fileServerXURL = window.fileServerXURL;
					if(!fileServerXURL){
						fileServerXURL="https://file-server-$ID.vetology.net";
					}
					fileServerXURL=fileServerXURL.replace('$ID',rand);
					var url = fileServerXURL + "/download/" + id;
					//url = "https://datastore.vetology.net/download/" + id;
					var xhr = new XMLHttpRequest();
					xhr.open("GET", url, true);
					xhr.responseType = "arraybuffer";
					xhr.timeout = XHR_TIMEOUT; // 15 minutes
					var to = setTimeout(
						function(){
							aborting = true;
							xhr.abort();
							retryOrFail('no response for 15s');
						}, 15000
					);
					xhr.onreadystatechange = function (e) {
						if (xhr.readyState === 4 && xhr.status !== 200) {
							if (aborting) {
								return;  // the watchdog that called abort() owns this failure
							}
							if (xhr.status === 404 || xhr.status === 410) {
								attempt = MAX_ATTEMPTS; // fail fast: the file isn't going to appear
							}
							retryOrFail('HTTP ' + xhr.status);
						}
					}
					xhr.addEventListener('progress', function(p){
						clearTimeout(to);
						to = setTimeout(
							function () {
								aborting = true;
								xhr.abort();
								retryOrFail('stalled mid-transfer for 5s');
							}, 5000
						);
						if (p.lengthComputable) {
							var loaded = p.loaded;
							var total = p.total;
							var percentComplete = Math.round(loaded / total * 100);
							var eventData = {
								imageId: "vetology:" + imageId,
								loaded: loaded,
								total: total,
								cached: 0,
								percentComplete: percentComplete,
								is_completed: (percentComplete === 100)
							};
							o._event("vetology_image_progress", eventData);
						}
					});

					xhr.onload = function(){
						clearTimeout(to);
						if (xhr.status === 200) {
							arraybuffer = xhr.response;
							o.options.data_usage.downloaded ++;
							o.options.data_usage.downloaded_bytes += arraybuffer.byteLength;
							o.options.db_size += arraybuffer.byteLength + imageId.length;
							var eventData = {
								imageId: "vetology:" + imageId,
								loaded: arraybuffer.byteLength,
								total: arraybuffer.byteLength,
								cached: 0,
								percentComplete: 100,
								is_completed: true
							};
							o._event("vetology_image_progress", eventData);
							o._event("vetology_image_loaded", eventData);
							if(typeof o.options.queue.download_secondary[imageId] != "undefined"){
								$.each(o.options.queue.download_secondary[imageId].deferred, function(i, d){
									d.resolve(imageId, arraybuffer);
								});
								delete o.options.queue.download_secondary[imageId];
							}
							if(typeof o.options.queue.download[imageId] != "undefined"){
								$.each(o.options.queue.download[imageId].deferred, function(i, d){
									d.resolve(imageId, arraybuffer);
								});
								delete o.options.queue.download[imageId];
							}
							o.options.queue.active --;
						}
					}
					xhr.onerror = function(e){
						console.log(e);
						retryOrFail('network error');
					}
					xhr.ontimeout = function(e){
						retryOrFail('no response for 15 minutes (native timeout)');
					}
					xhr.send();
				}
			},
			"_getDatabase": function(){
				var o = this;
				var deferred = new $.Deferred();
				o.options.indexedDB = window.indexedDB || window.webkitIndexedDB || window.msIndexedDB;
				var IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange;
				var openCopy = indexedDB && indexedDB.open;
				window.IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction;
				if(window.IDBTransaction){
					window.IDBTransaction.READ_WRITE = IDBTransaction.READ_WRITE || 'readwrite';
					window.IDBTransaction.READ_ONLY = IDBTransaction.READ_ONLY || 'readonly';
				}
				o.options.database.connection = o.options.indexedDB.open(o.options.database.name, o.options.database.version);
				o.options.database.connection.onupgradeneeded = function(e){
					var idb  = e.target.result;
					var store = idb.createObjectStore(o.options.database.schema.name, {keyPath: o.options.database.schema.keyPath, autoIncrement: o.options.database.schema.autoIncrement});
					$.each(o.options.database.indexes, function(name, params){
						store.createIndex(name, o.options.database.schema.name, params);
					});
				};
				o.options.database.connection.onsuccess = function(e){
					o.options.database.connection = o.options.database.connection.result;
					o.options.database.ready = true;
					o.options.database.schema.exists = $.inArray(o.options.database.schema.name, o.options.database.connection.objectStoreNames) !== -1;
					if(o.options.database.schema.exists){
						var trans = o.options.database.connection.transaction(o.options.database.schema.name, IDBTransaction.READ_ONLY);
						trans.onerror = function(e){
							console.log(e);
						}
						trans.onsuccess = function(e){
							deferred.resolve();
							o._setStorageUsed();
						}	
						trans.oncomplete = function(e){
							deferred.resolve();
							o._setStorageUsed();
						}	
						trans.onblocked = function(e) {
							console.log(e);
						};
					} else {
						o.flushDB();
					}
					
				};
				o.options.database.connection.onblocked = function(e) {
					console.log(e);
				};
				o.options.database.connection.onerror = function(e){
					console.log(e);
				};
				return deferred.promise();
			},
			"_setStorageUsed": function(){
				var o = this;
				if(o.options.database.support){
					var transaction = o.options.database.connection.transaction(o.options.database.schema.name, IDBTransaction.READ_ONLY);
					var objectStore = transaction.objectStore(o.options.database.schema.name);
					var size = 0;
					var cursor = objectStore.openCursor();
					cursor.onerror = function(event){
						console.log(event);
					}
					cursor.onblocked = function(event){
						console.log(event);
					}
					cursor.onsuccess = function(event){
						var cursor = event.target.result;
						if(cursor){
							var res = cursor.value;
							var s = res.id.length + res.arraybuffer.byteLength;
							size += s;
							o.options.items.push({s1:res.stamp,s2:s});
							o.options.images[res.id] = {
								id: res.id,
								state: 3,
								loaded: true,
								cached: true,
								loadingThumbs: true,
								loadedThumbs: false,
								not_found: res.not_found,
								size: s,
								callbacks: [],
							}
							o.imageGetThumbs(res.id, res.arraybuffer);
							cursor.continue();
						} else {
							o.options.db_size = size;
							o._getStorageUsed(0);
						}
						o.options.is_ready = true;
					}
				} else {
					o.options.is_ready = true;
				}
			},
			"removeObjectStorage": function(){
				var o = this;
				if(o.options.database.schema.exists){
					o.options.database.schema.trash = true;
					o.options.database.connection.setVersion(5);
				}
			},
			"flushDB": function(){
				var o = this;
				$("body").Vetology("vetologyLoadStart", "Please wait while the DB is truncated.", "Please wait while the DB is truncated.<br>This is taking longer than usual as the database maybe in use in other tabs");
				localStorage.setItem("db_flushed", true);
				localStorage.removeItem("db_flushed");
				var request = indexedDB.deleteDatabase(o.options.database.name);
				request.onsuccess = function(){
					$("body").Vetology("vetologyLoadStart", "Database has been truncated, reinitializing.", "Database has been truncated, reinitializing.<br>This is taking longer than usual...");
					location.reload();
				};
				request.onerror = function(e){
					$("body").Vetology("vetologyLoadStart", "Database could not be truncated: " + e, "Database could not be truncated: " + e + "<br>This is taking longer than usual...");
					setTimeout(
						function(){
							$("body").Vetology("vetologyLoadEnd");
						}, 3000
					);
				};
				request.onblocked = function(e) {
					try {
						$("body").Vetology("vetologyLoadStart", "Attempting to close open connections", "Attempting to close open connections<br>This is taking longer than usual...");
						o.options.database.connection.close();
					} catch(e){
						console.log(e);
					}
				};
			},
			"getLoadedDataSet": function(){
				return this.options.data_usage;
			},
			"isReady": function(){
				var o = this;
				var deferred = new $.Deferred();
				var i = setInterval(
					function(){
						if(o.options.is_ready){
							clearInterval(i);
							return deferred.resolve(true);
						}
					}, 10
				);
				return deferred.promise();
			},
			"_purgeItems": function(limit){
				var o = this;
				var deferred = new $.Deferred();
				o.options.purger.purging.target += limit;
				if(o.options.purger.purging){
					var i = setInterval(function(){
						if(!o.options.purger.purging){
							clearInterval(i);
							deferred.resolve();
						}
					},10);
				} else {
					o.options.purger.purging = true;
					var transaction = o.options.database.connection.transaction(o.options.database.schema.name, IDBTransaction.READ_WRITE);
					var objectStore = transaction.objectStore(o.options.database.schema.name);
					var size = 0;
					var items = [];
					objectStore.openCursor().onsuccess = function(event){
						var cursor = event.target.result;
						if(cursor){
							items.push(cursor.value);
							cursor.continue();
						}
						items.sort(function(o1, o2) {
							return o1.stamp - o2.stamp;
						});
						$.each(items, function(i, entry){
							var rem = entry.arraybuffer.byteLength+entry.id.length;
							try {
								objectStore.delete(entry.id);
								o.options.db_size -= rem;
								o.options.purger.purging.target -= rem;
							} catch(e){
								console.log(e);
							}
							if(o.options.purger.purging.target < 1){
								return false;
							}
						});
						localStorage.setItem("db_modified", true);
						localStorage.removeItem("db_modified");
						o._setStorageUsed();
						o.options.purger.purging = false;
						deferred.resolve();
					}
				}
				return deferred.promise();
			},
			"_getStorageUsed": function(add){
				var o = this;
				if(o.options.database.support){
					var size = o.options.db_size;
					var hlimit = (size + add) > o.options.QuotaLimit;
					var i = -1;
					var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
					do {
						size = size / 1024;
						i++;
					} while (size > 1024);
					size = Math.max(size, 0.1).toFixed(1);
					size = size + byteUnits[i];
					$(".data_db_size").removeClass("label-danger").addClass("label-warning").find("span.data_db_size_detail").html(size);
					if(hlimit){
						$(".data_db_size").removeClass("label-warning").addClass("label-danger");
						return true;
					}
					return false;
				} else {
					return false;
				}				
			},
			"_putDownload": function(entry, arraybuffer, callback){
				var o = this;
				var new_size = entry.arraybuffer.byteLength+entry.id.length;
				var hit_limit = o._getStorageUsed(new_size);
				if(hit_limit){
					$.when(o._purgeItems(new_size*2)).then(
						function(){
							hit_limit = false;
						}
					);
				}
				o.options.images[entry.id].loadingThumbs = true;
				o.options.images[entry.id].loadedThumbs = false;
				o.imageGetThumbs(entry.id, arraybuffer);
				if(o.options.database.support){
					var i = setInterval(
						function(){
							if(!hit_limit){
								clearInterval(i);
								try {
									var request = indexedDB.open(o.options.database.name, o.options.database.version);
									request.onsuccess = function(e){
										var idb = e.target.result;
										var trans = idb.transaction(o.options.database.schema.name, IDBTransaction.READ_WRITE);
										var store = trans.objectStore(o.options.database.schema.name);
										var requestAdd = store.add(entry);
										requestAdd.onsuccess = function(e){
											idb.close();
											localStorage.setItem("db_modified", true);
											localStorage.removeItem("db_modified");
										};
										requestAdd.onfailure = function(e){
											idb.close();
										};
									};
								} catch(e){
									console.warn(e);
								} finally {
									callback();
								}
							}
						}, 10
					);
				} else {
					callback();
				}
			},
			"prepareImage": function(imageId, callback, needs_promise){
				var o = this;
				imageId = imageId.replace('vetology:', '');
				if(typeof o.options.images[imageId] == "undefined"){
					o.options.images[imageId] = {
						id: imageId,
						state: 1,
						loaded: false,
						cached: false,
						not_found: false,
						callbacks: []
					}
					if(imageId == "no_matches"){
						o.options.images[imageId].state = 1;
						o.options.images[imageId].sidebar_left = o.options.no_matches;
						o.options.images[imageId].sidebar_right = o.options.no_matches;
						o.options.images[imageId].pagination_small = o.options.no_matches;
						o.options.images[imageId].pagination_medium = o.options.no_matches;
						o.options.images[imageId].arraybuffer = null;
						o.options.images[imageId].stamp = 9999999999;
						o.options.images[imageId].callbacks.push(callback);
						return true;
					}
				} else {
					if($.inArray(imageId, o.options.images_used) === -1 && o.options.images[imageId].cached == true){
						o.options.data_usage.total ++;
						o.options.data_usage.cached ++;
						o.options.data_usage.cached_bytes += o.options.images[imageId].size;
					}
					o.options.images_used.push(imageId);
				}
				if(o.options.images[imageId].not_found){
					return false;
				}
				switch(o.options.images[imageId].state){
					case 0:
						o._getImageInfo(imageId, callback, needs_promise);
					break;
					 case 1:
						var deferred = new $.Deferred();
						o.options.images[imageId].state = 2;
						$.when(o._downloadAsset(imageId)).then(function(imageId, arraybuffer){
							o.options.images[imageId].arraybuffer = arraybuffer;
							o._putDownload(o.options.images[imageId], arraybuffer, function(){
								o.options.images[imageId].state = 3;
								o._renderCornerstoneImage(imageId, arraybuffer, function(image){
									deferred.resolve(image);
								});
							});
						},
						function(crypt, event) {
							deferred.reject(crypt, event);
						});
						return deferred.promise();

					case 2:
						var deferred = new $.Deferred();
						var maxAttempts = 5;
						var dr = setInterval(
							function(){
								if(o.options.images[imageId].state == 3){
									clearInterval(dr);
									var eventData = {
										imageId: "vetology:" + imageId,
										loaded: o.options.images[imageId].arraybuffer.byteLength,
										total: o.options.images[imageId].arraybuffer.byteLength,
										cached: o.options.images[imageId].arraybuffer.byteLength,
										percentComplete: 100,
										is_completed: true
									};
									o._event("vetology_image_progress", eventData);
									o._event("vetology_image_loaded", eventData);
									o._renderCornerstoneImage(imageId, o.options.images[imageId].arraybuffer, function(image){
										deferred.resolve(image);
									});
								} else {
									maxAttempts--;
									if (maxAttempts <= 0) {
										clearInterval(dr);
										deferred.reject(imageId, null);
									}
								}
							}, 10
						);
						return deferred.promise();

					case 3:
						var deferred = new $.Deferred();
						$.when(o._getRecord({id:imageId})).then(function(d){
							if(imageId != "no_matches"){
								var eventData = {
									imageId: "vetology:" + imageId,
									loaded: d.arraybuffer.byteLength,
									total: d.arraybuffer.byteLength,
									cached: d.arraybuffer.byteLength,
									percentComplete: 100,
									is_completed: true
								};
								o._event("vetology_image_progress", eventData);
								o._event("vetology_image_loaded", eventData);
							}
							o._renderCornerstoneImage(imageId, d.arraybuffer, function(image){
								deferred.resolve(image);
							});
						},
						function(crypt, event) {
							deferred.reject(crypt, event);
						});
						return deferred.promise();

				}
			},
			"imageGetThumbs": function(imageId, arraybuffer){
				var o = this;
				var data = {
					"loaded": 0
				};
				let imageUrl;
				if(imageId == "no_matches"){
					imageUrl = o.options.no_matches;
				} else {
					var blob = new Blob([arraybuffer]);
					var urlCreator = window.URL || window.webkitURL;
					imageUrl = urlCreator.createObjectURL(blob);
				}
				var image = new Image();
				image.onload = function(){
					if(urlCreator){
						urlCreator.revokeObjectURL(imageUrl);
					}
					var process = true;
					var ratio = image.width / image.height;
					$.when(o._genImageThumb(image, 280, 189, ratio)).then(
						function(base64){
							data.sidebar_left = base64;
							data.loaded ++;
						}
					);
					$.when(o._genImageThumb(image, 60, 60, ratio)).then(
						function(base64){
							data.sidebar_right = base64;
							data.pagination_medium = base64;
							data.loaded ++;
						}
					);
					$.when(o._genImageThumb(image, 30, 30, ratio)).then(
						function(base64){
							data.pagination_small = base64;
							data.loaded ++;
						}
					);
					var ri = setInterval(
						function(){
							if(data.loaded === 3){
								clearInterval(ri);
								o.options.images[imageId].sidebar_left = data.sidebar_left;
								o.options.images[imageId].sidebar_right = data.sidebar_right;
								o.options.images[imageId].pagination_small = data.pagination_small;
								o.options.images[imageId].pagination_medium = data.pagination_medium;
								o.options.images[imageId].loadingThumbs = true;
								o.options.images[imageId].loadedThumbs = true;
							}
						}, 5
					);
				};
				image.onerror = function (error) {
					if(urlCreator){
						urlCreator.revokeObjectURL(imageUrl);
					}
				};
				image.src = imageUrl;
			},
			"_genImageThumb": function(image, width, height){
				var o = this;
				var deferred = new $.Deferred();
				var canvas = document.createElement("canvas");
				//canvas.height = image.height * width / image.width;
				canvas.height = height;
				canvas.width = image.width * height / image.height;
				canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
				var jpegUrl4 = canvas.toDataURL("image/jpeg");
				canvas = null;
				deferred.resolve(jpegUrl4);
				/*o.options.resizer.resize(image, canvasFinal).then(
					function(){
						//canvas.getContext('2d', {alpha: true}).drawImage(canvasFinal, 0, 0);
						var jpegUrl4 = canvasFinal.toDataURL("image/jpeg");
						canvas = null;
						canvasFinal = null;
						ctx = null;
						deferred.resolve(jpegUrl4);
					}
				);*/
				return deferred.promise();
			},
			"_getImageInfo": function(imageId, callback, needs_promise){
				var o = this;
				if(o.options.workers.support){
					var index;
					var wi = setInterval(
						function(){
							var active = false;
							$.each(o.options.workers.workers, function(i,w){
								if(!w.isWorking){
									clearInterval(wi);
									index = i;
									o.options.workers.workers[index].isWorking = true;
									active = true;
									return false;
								}
							});
							if(active){
								var cev = function(e){
									if(e.data.action){
										switch(e.data.action){
											case "loaded":
												if(e.data.json){
													o.options.workers.workers[index].removeEventListener("message", cev, true);
													o.options.workers.workers[index].isWorking = false;
													var data = e.data.json;
													o.options.images[imageId].state = 1;
													o.options.images[imageId].arraybuffer = null;
													o.options.images[imageId].stamp = data.stamp;
													o.options.images[imageId].crypt = data.crypt;
													o.options.images[imageId].callbacks.push(callback);
													o.options.images_used.downloaded_bytes += data.length;
													if(needs_promise){
														return o.prepareImage(imageId, callback, needs_promise);
													}
												} else {
													console.log(e);
												}
											break;
											case "error":
												console.warn("Retrying:", e.data.error);
											break;
										}
									}
								}
								o.options.workers.workers[index].addEventListener("message", cev, false);
								o.options.workers.workers[index].postMessage({action:"json",url:"/download/" + imageId + "?tn=100"});
							}
						}, 10
					);
				} else {
                    const fileServerURL = window.fileServerURL;
                    const appURL = window.appURL;
					var rand = Math.floor(Math.random() * 15) + 1;
                    var fileServerXURL = window.fileServerXURL;
                    if(!fileServerXURL){
                        fileServerXURL="https://file-server-$ID.vetology.net";
                    }
                    fileServerXURL=fileServerXURL.replace('$ID',rand);
                    let url = "https://" + appURL + '.' + fileServerURL + '/download/' + imageId + "?tn=100";
                    if (fileServerURL == '' || appURL == '') {
                        // keep old behavior if new env names are not present
                        url = fileServerXURL + "/download/"  + imageId + "?tn=100";
                        url = "/download/" + imageId + "?tn=100";
                    }
					$.ajax(
						{
							type: 'GET', 
							url: url, 
							dataType: 'JSON',
							cache: false,
							success: function(data){
								o.options.images[imageId].state = 1;
								o.options.images[imageId].arraybuffer = null;
								o.options.images[imageId].stamp = data.stamp;
								o.options.images[imageId].crypt = data.crypt;
								o.options.images[imageId].callbacks.push(callback);
								o.options.images_used.downloaded_bytes += data.length;
								if(needs_promise){
									return o.prepareImage(imageId, callback, needs_promise);
								}
							},
							error: function(jqXHR, textStatus, errorThrown){
								if(jqXHR.status !== 404){
									o._getImageInfo(imageId, callback);
								} else {
									o.options.images[imageId].not_found = true;
								}
							}
						}
					);
				}	
			},
			"_getRecord": function(data){
				var o = this;
				var deferred = new $.Deferred();
				if(o.options.database.support){
					var transaction = o.options.database.connection.transaction([o.options.database.schema.name], IDBTransaction.READ_ONLY);
					var objectStore = transaction.objectStore(o.options.database.schema.name);
					var objectStoreRequest = objectStore.get(data.id);
					objectStoreRequest.onsuccess = function(event){
						var record = objectStoreRequest.result;
						deferred.resolve(record);
					}
				} else {
					deferred.resolve(o.options.images[data.id]);
				}
				return deferred.promise();
			},
			"_removeRecord": function(imageId){
				o.options.db.remove({
					From: "downloads",
					Where: {
						stamp: r.s1
					}
				});
			},
			"imageThumbsReady": function(imageId){
				var o = this;
				imageId = imageId.replace('vetology:', '');
				if(typeof o.options.images[imageId] == "undefined"){
					o.prepareImage(imageId);
				}
				var deferred = new $.Deferred();
				if(typeof o.options.images[imageId] != "undefined" && o.options.images[imageId].loadedThumbs){
					return deferred.resolve(o.options.images[imageId]);
				}
				var i = setInterval(
					function(){
						if(typeof o.options.images[imageId] != "undefined" && o.options.images[imageId].loadedThumbs){
							clearInterval(i);
							return deferred.resolve(o.options.images[imageId]);
						}
					}, 100
				);
				return deferred.promise();
			},
			"imageReady": function(imageId, state = 1, pixelSpacing = false){
				var o = this;
				imageId = imageId.replace('vetology:', '');
				var deferred = new $.Deferred();
				if(typeof o.options.images[imageId] == "undefined"){
					var ret = o.prepareImage(imageId);
                    if (pixelSpacing) {
                        o.options.images[imageId].pixelSpacing = pixelSpacing;
                    }
					if (typeof ret == "object") {
						ret.then(function() {}, function(crypt, event) {
                            if (o.options.images[imageId].state >= state) {
                                return deferred.resolve(o.options.images[imageId]);
                            }
						});
					}
				} else if (pixelSpacing) {
                    o.options.images[imageId].pixelSpacing = pixelSpacing;
				}
				if(typeof o.options.images[imageId] != "undefined" && o.options.images[imageId].state >= state){
					return deferred.resolve(o.options.images[imageId]);
				}
				var attempts = 18000;  // 18000 attempts x .1s = 30 minutes
				var i = setInterval(
					function(){
						attempts--;
						if(typeof o.options.images[imageId] != "undefined" && o.options.images[imageId].state >= state){
							clearInterval(i);
							return deferred.resolve(o.options.images[imageId]);
						}
						if (attempts < 0) {
							clearInterval(i);
								var ret = o.prepareImage(imageId);
								if (typeof ret == "object") {
									return deferred.reject(null);
								}

						}
					}, 100
				);
				return deferred.promise();
			},
			"getWorkers": function(){
				console.log(o.options.workers);
			},
			"_downloadAsset": function(imageId, deferred, worker){
				/*
				Server 16-30 are fast serving servers which don't use the DB
				Server 1-15 are used when the file is not available in the delivery servers
				IF the crypt property is defined and !== false then use 1-15 else 16-30
				*/
				var o = this;
				var deferred = new $.Deferred();
				if(typeof o.options.queue.download[imageId] != "undefined"){
					o.options.queue.download[imageId].deferred.push(deferred);
					return deferred.promise();
				}
				o.options.data_usage.total ++;
				o.options.queue.download[imageId] = {
					"deferred": [deferred],
					"active": false
				};
				return deferred.promise();
			},
			"_event": function(type, data){
				var e = jQuery.Event(type);
				e.detail = data;
				$(document).trigger(e);
			},
			"loadImage": function(imageId){
				var o = this;
				return o.prepareImage(imageId);
			},
			"Base64Binary": {
				_keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
				/* will return a  Uint8Array type */
				decodeArrayBuffer: function(input) {
					var bytes = (input.length/4) * 3;
					var ab = new ArrayBuffer(bytes);
					this.decode(input, ab);
					return ab;
				},

				removePaddingChars: function(input){
					var lkey = this._keyStr.indexOf(input.charAt(input.length - 1));
					if(lkey == 64){
						return input.substring(0,input.length - 1);
					}
					return input;
				},

				decode: function (input, arrayBuffer) {
					//get last chars to see if are valid
					input = this.removePaddingChars(input);
					input = this.removePaddingChars(input);

					var bytes = parseInt((input.length / 4) * 3, 10);
					
					var uarray;
					var chr1, chr2, chr3;
					var enc1, enc2, enc3, enc4;
					var i = 0;
					var j = 0;
					
					if (arrayBuffer)
						uarray = new Uint8Array(arrayBuffer);
					else
						uarray = new Uint8Array(bytes);
					
					input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
					
					for (i=0; i<bytes; i+=3) {	
						//get the 3 octects in 4 ascii chars
						enc1 = this._keyStr.indexOf(input.charAt(j++));
						enc2 = this._keyStr.indexOf(input.charAt(j++));
						enc3 = this._keyStr.indexOf(input.charAt(j++));
						enc4 = this._keyStr.indexOf(input.charAt(j++));
				
						chr1 = (enc1 << 2) | (enc2 >> 4);
						chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
						chr3 = ((enc3 & 3) << 6) | enc4;
				
						uarray[i] = chr1;			
						if (enc3 != 64) uarray[i+1] = chr2;
						if (enc4 != 64) uarray[i+2] = chr3;
					}
				
					return uarray;	
				}
			},
			"_renderCornerstoneImage": function(imageId, arraybuffer, callback){
				var o = this;
				var imageUrl;
				if(imageId == "no_matches"){
					imageUrl = o.options.no_matches;
				} else {
					var blob = new Blob([arraybuffer]);
					var urlCreator = window.URL || window.webkitURL;
					var imageUrl = urlCreator.createObjectURL(blob);
				}
				var image = new Image();
				image.onload = function(){
					if(urlCreator){
						urlCreator.revokeObjectURL(imageUrl);
					}
					var cornerstone_image = o._getImageObject(imageId, image.naturalWidth, image.naturalHeight);
					cornerstone_image.getImage = function(){
						return image;
					}
					cornerstone_image.getCanvas = function(){
						if(o.options.currentImageId !== imageId){
							o.options.canvas.height = image.naturalHeight;
							o.options.canvas.width  = image.naturalWidth;
							var context = o.options.canvas.getContext("2d");
							context.drawImage(image, 0, 0);
							o.options.currentImageId = imageId;
						}
						return o.options.canvas;
					}
					cornerstone_image.getPixelData = function(a,b,c,d){
						var context = void 0;
						if(o.options.currentImageId === imageId){
							context = o.options.canvas.getContext("2d");
						} else {
							o.options.canvas.height = image.naturalHeight;
							o.options.canvas.width  = image.naturalWidth;
							context = o.options.canvas.getContext("2d");
							context.drawImage(image, 0, 0);
							o.options.currentImageId = imageId;
						}
						return context.getImageData(0, 0, image.naturalWidth, image.naturalHeight).data;
					}
					callback(cornerstone_image);
				};
				image.onerror = function (error) {
					if(urlCreator){
						urlCreator.revokeObjectURL(imageUrl);
					}
				};
				image.src = imageUrl;
			},
			"_getImageObject": function(imageId, width, height){
                let pixelSpacing = [0.14, 0.14];
                if (typeof this.options.images[imageId].pixelSpacing != 'undefined') {
                    pixelSpacing = this.options.images[imageId].pixelSpacing.split('\\');
                }

				var image = {
					imageId: "vetology:" + imageId,
					minPixelValue: 0,
					maxPixelValue: 255,
					slope: 1.0,
					intercept: 0,
					windowCenter: 128,
					windowWidth: 255,
					rows: height,
					columns: width,
					height: height,
					width: width,
					color: true,
					rgba: false,
					columnPixelSpacing: pixelSpacing[1],
					rowPixelSpacing: pixelSpacing[0],
					invert: false,
					sizeInBytes: width * height * 4
				};
				return image;
			},
			"thumbnailer": {
				"create": function(elem, img, sx, lobes, deferred){
					this.ready = false;
					this.deferred = deferred;
					this.lanczosCreate = function(lobes){
						return function(x) {
							if (x > lobes)
								return 0;
							x *= Math.PI;
							if (Math.abs(x) < 1e-16)
								return 1;
							var xx = x / lobes;
								return Math.sin(x) * Math.sin(xx) / x / xx;
						};
					}
					this.process1 = function(self, u){
						self.center.x = (u + 0.5) * self.ratio;
						self.icenter.x = Math.floor(self.center.x);
						for (var v = 0; v < self.dest.height; v++) {
							self.center.y = (v + 0.5) * self.ratio;
							self.icenter.y = Math.floor(self.center.y);
							var a, r, g, b;
							a = r = g = b = 0;
							for (var i = self.icenter.x - self.range2; i <= self.icenter.x + self.range2; i++) {
								if (i < 0 || i >= self.src.width)
									continue;
								var f_x = Math.floor(1000 * Math.abs(i - self.center.x));
								if (!self.cacheLanc[f_x])
									self.cacheLanc[f_x] = {};
								for (var j = self.icenter.y - self.range2; j <= self.icenter.y + self.range2; j++) {
									if (j < 0 || j >= self.src.height)
										continue;
									var f_y = Math.floor(1000 * Math.abs(j - self.center.y));
									if (self.cacheLanc[f_x][f_y] == undefined)
										self.cacheLanc[f_x][f_y] = self.lanczos(Math.sqrt(Math.pow(f_x * self.rcp_ratio, 2)
												+ Math.pow(f_y * self.rcp_ratio, 2)) / 1000);
									var weight = self.cacheLanc[f_x][f_y];
									if (weight > 0) {
										var idx = (j * self.src.width + i) * 4;
										a += weight;
										r += weight * self.src.data[idx];
										g += weight * self.src.data[idx + 1];
										b += weight * self.src.data[idx + 2];
									}
								}
							}
							var idx = (v * self.dest.width + u) * 3;
							self.dest.data[idx] = r / a;
							self.dest.data[idx + 1] = g / a;
							self.dest.data[idx + 2] = b / a;
						}

						if (++u < self.dest.width)
							setTimeout(self.process1, 0, self, u);
						else
							setTimeout(self.process2, 0, self);
					}
					this.process2 = function(self){
						var o = this;
						self.canvas.width = self.dest.width;
						self.canvas.height = self.dest.height;
						self.ctx.drawImage(self.img, 0, 0, self.dest.width, self.dest.height);
						self.src = self.ctx.getImageData(0, 0, self.dest.width, self.dest.height);
						var idx, idx2;
						for (var i = 0; i < self.dest.width; i++) {
							for (var j = 0; j < self.dest.height; j++) {
								idx = (j * self.dest.width + i) * 3;
								idx2 = (j * self.dest.width + i) * 4;
								self.src.data[idx2] = self.dest.data[idx];
								self.src.data[idx2 + 1] = self.dest.data[idx + 1];
								self.src.data[idx2 + 2] = self.dest.data[idx + 2];
							}
						}
						self.ctx.putImageData(self.src, 0, 0);
						self.canvas.style.display = "block";
						var jpegUrl = self.canvas.toDataURL("image/jpeg");
						console.log(jpegUrl);
						self.deferred.resolve(jpegUrl);	
					}
					this.canvas = elem;
					elem.width = img.width;
					elem.height = img.height;
					elem.style.display = "none";
					this.ctx = elem.getContext("2d");
					this.ctx.drawImage(img, 0, 0);
					this.img = img;
					this.src = this.ctx.getImageData(0, 0, img.width, img.height);
					this.dest = {
						width : sx,
						height : Math.round(img.height * sx / img.width),
					};
					this.dest.data = new Array(this.dest.width * this.dest.height * 3);
					this.lanczos = this.lanczosCreate(lobes);
					this.ratio = img.width / sx;
					this.rcp_ratio = 2 / this.ratio;
					this.range2 = Math.ceil(this.ratio * lobes / 2);
					this.cacheLanc = {};
					this.center = {};
					this.icenter = {};
					setTimeout(this.process1, 0, this, 0);
				}
			}
		}
	);
})(jQuery);